import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SpareInventoriedType } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectSpareInventoriedType = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_SpareInventoriedType);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDSpareInventoriedType === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDSpareInventoriedType,
                    label: `${found.DataBeanProperties.IDSpareInventoriedType} - ${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1
        }
        instance.getSpareInventoriedTypeCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDSpareInventoriedType,
        label: `${item.DataBeanProperties.IDSpareInventoriedType} - ${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Maquina"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Maquina..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
